import {
  PREMIUM_PLAN_PURCHASE_DETAILS,
  PRICING_PLANS,
  USER_ACCOUNT,
  USER_ACTIVATE,
  USER_LOGIN,
  USER_RESET_PASSWORD,
  USER_RESET_PASSWORD_FINISH,
  USER_SIGNUP,
} from "app/utils/constants/paths";
import jwtAuthAxios from "./auth/jwtAuth";
import { PaymentStatus } from "app/utils/constants/paymentStatus";

const authServices = {};

authServices.getCurrentUser = async () => {
  const { data } = await jwtAuthAxios.get(USER_ACCOUNT);
  return data;
};

//loginCreds must be {email: "abc@example.com", password: "ABC123DEF"}
authServices.signIn = async (loginCreds) => {
  const { data } = await jwtAuthAxios.post(USER_LOGIN, loginCreds);
  return data;
};

authServices.signUp = async (signUpCreds) => {
  const { data } = await jwtAuthAxios.post(USER_SIGNUP, signUpCreds);
  return data;
};

authServices.resetPassword = async (email) => {
  const { data } = await jwtAuthAxios.post(USER_RESET_PASSWORD, email, {
    headers: {
      "Content-Type": "text/plain",
    },
  });
  return data;
};

authServices.pricingPlans = async () => {
  const { data } = await jwtAuthAxios.get(PRICING_PLANS);
  return data;
};

authServices.planDetails = async (id) => {
  const { data } = await jwtAuthAxios.get(`${PRICING_PLANS}/${id}`);
  return data;
};

authServices.coursePurchaseDetails = async (planId) => {
  try {
    const { data } = await jwtAuthAxios.post(PREMIUM_PLAN_PURCHASE_DETAILS, {
      paymentStatus: PaymentStatus.PAYMENT_INITIATED,
      premiumPlansId: planId,
    });
    return data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        "Failed to create course purchase details"
    );
  }
};

authServices.updateCoursePurchaseDetails = async (id, updateData) => {
  try {
    const { data } = await jwtAuthAxios.put(
      `${PREMIUM_PLAN_PURCHASE_DETAILS}`,
      updateData
    );
    return data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        "Failed to update course purchase details"
    );
  }
};

authServices.activateAccount = async (key) => {
  try {
    const { data } = await jwtAuthAxios.get(`${USER_ACTIVATE}?key=${key}`);
    return data;
  } catch (error) {
    // console.log("Failed to activate account:", error.response?.data.title);
    throw new Error(error.response?.data.title);
  }
};

authServices.resetPasswordFinish = async (key, newPassword) => {
  try {
    const { data } = await jwtAuthAxios.post(USER_RESET_PASSWORD_FINISH, {
      key,
      newPassword,
    });
    return data;
  } catch (error) {
    throw new Error(error.response?.data?.title || "Failed to reset password");
  }
};

export default authServices;
